import { Map } from 'immutable'

// TODO: grab this directly from the draft-js-alignment-plugin decorator.
// For now, just duplicating its style logic. Reference URL:
// https://github.com/draft-js-plugins/draft-js-plugins/blob/master/draft-js-alignment-plugin/src/createDecorator.js
const _IMAGE_ALIGNMENT_MAP = {
  left: { float: 'left' },
  right: { float: 'right' },
  center: {
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
  },
}

export function tokenize(entityMap, str, tokenizer = '@') {
  const tokens = new Set()
  let token,
    entity

  for (const entKey in entityMap) {
    entity = entityMap[entKey]

    if (entity.type === 'mention') {
      token = extractToken(entity.data.mention)
      tokens.add(token)
    }
  }

  const text = str.split(/\b/).map((word) => {
    if (tokens.has(word)) {
      return `${tokenizer}${word}`
    }
    return word
  }).join('')

  return { text, tokens: Array.from(tokens) }
}

/**
 * @return, {Object} style configuration for rich emails
 * @see https://github.com/sstur/draft-js-export-html
 */
export function getDefaultRichStyleConfig() {
  const entityStyleFn = (entity) => {
    const entityType = entity.get('type').toLowerCase()

    if (entityType === 'image') {
      const data = entity.getData()
      const imageAlignmentRules = _IMAGE_ALIGNMENT_MAP[data.alignment] || {}

      return {
        element: 'img',
        attributes: {
          src: data.src,
          alt: 'image',
        },
        style: {
          width: `${data.width}%`,
          maxWidth: '600px',
          height: 'auto',
          ...imageAlignmentRules,
        },
      }
    } else if (entityType === 'colorblock') {
      return genColorEntityStyle({
        ...entity.getData().styles,
        textAlign: 'center',
        fontSize: '32px',
        padding: '10px',
        wordWrap: 'break-word',
      })
    } else if (entityType === 'header') {
      const { backgroundColor } = entity.getData().styles
      return genColorEntityStyle({ backgroundColor, textAlign: 'center', fontSize: '32px' })
    } else if (entityType === 'footer') {
      const { backgroundColor } = entity.getData().styles
      return genColorEntityStyle({ backgroundColor, textAlign: 'left', fontSize: '16px' })
    }
  }

  const blockStyleFn = (block) => {
    const blockType = block.getType()

    if (blockType === 'blockquote') {
      return {
        style: {
          borderLeft: '5px solid #eee',
          color: '#666',
          fontFamily: "'Hoefler Text', 'Georgia', 'serif'",
          fontStyle: 'italic',
          margin: '16px 0',
          padding: '10px 20px',
        },
      }
    } else if (blockType === 'atomic') {
      return {
        style: {
          margin: '10px 0',
        },
      }
    } else if (blockType === 'colorblock') {
      return genColorBlockStyle()
    } else if (blockType === 'colorblock-header') {
      return genColorBlockStyle('#8fc51d')
    } else if (blockType === 'colorblock-footer') {
      return genColorBlockStyle('#ac412a')
    }
  }

  return { blockStyleFn, entityStyleFn }
}

function extractToken(mention) {
  return Map.isMap(mention) ?
    mention.toJS().name : // mystery: why does this become an Immutable Map?
    mention.name
}

function genColorEntityStyle(styleRules = {}) {
  return {
    element: 'div',
    attributes: {},
    style: {
      margin: '20px auto',
      padding: '20px',
      width: '600px',
      color: 'white',
      ...styleRules
    }
  }
}

function genColorBlockStyle(backgroundColor = '#9bc0c7') {
  return {
    attributes: {},
    style: {
      textAlign: 'center',
      fontSize: '24px',
      fontWeight: 'bold',
      padding: '20px',
      width: '600px',
      backgroundColor,
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/draft-state/utils.js